import { initReactI18next } from 'react-i18next';

import en from '@fe-share-utils/i18n-web/en.json';
import ja from '@fe-share-utils/i18n-web/ja.json';
import zhTW from '@fe-share-utils/i18n-web/zh-TW.json';
import i18n from 'i18next';

const resources = {
  en: { translation: en },
  zhTW: { translation: zhTW },
  ja: { translation: ja },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'jaJP',
  fallbackLng: 'jaJP',
  detection: {
    order: [
      'localStorage',
      'cookie',
      'htmlTag',
      'path',
      'subdomain',
      'navigator',
    ],
    caches: ['localStorage', 'cookie'],
  },
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
